import { MapTo } from "@adobe/aem-react-editable-components";
import { PageTitle } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const ReferralStatsDashboardEditConfig = {
    emptyLabel: "Page Title",
    isEmpty: (props) => {
        return !props.title || !props.text;
    },
    getProps: (props) => {
        return {
            title: props.title,
            text: props.text,
        };
    },
};
export default MapTo("loyalty/components/pageTitle")(withAemAuthoring(PageTitle, ReferralStatsDashboardEditConfig));
